import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import store from "@/store"

const Layout = () => import('@/views/Layout')
const Home = () => import('@/views/home/index')
const News = () => import('@/views/news/index')
const Pay = () => import('@/views/user/pay/index')
const PayMent = () => import('@/views/user/pay/components/payment.vue')

const Mine = () => import('@/views/user/mine/index.vue')

const CheckOut = () => import('@/views/user/checkout/index')
const NewsDetail = () => import('@/views/newsdetail/index')
/* const NewsDesc = () => import('@/views/newspolicy/components/news-detail.vue') */
const NewsPolicy = () => import('@/views/newspolicy/index')
const NewsNotice = () => import('@/views/newsnotice/index')
const NewsList = () => import('@/views/newslist/index.vue')

const LineList = () => import('@/views/examline/index.vue')
const LineDetail = () => import('@/views/examline/components/line-detail.vue')

const LineItem = () => import('@/views/examitem/index.vue')

const GuideList = () => import('@/views/guide/index.vue')

const GuideItem = () => import('@/views/guideitem/index.vue')
const GuideDetail = () => import('@/views/guideitem/components/guide-detail.vue')

const AdviceList = () => import('@/views/advice/index.vue')

const AdviceItem = () => import('@/views/adviceitem/index.vue')
const AdviceDetail = () => import('@/views/adviceitem/components/advice-detail.vue')

const Video = () => import('@/views/video/index')
const VideoDetail = () => import('@/views/video-detail/index')
const VideoPlay = () => import('@/views/video-play/index')
const Books = () => import('@/views/books/index')
const BooksDetail = () => import('@/views/booksdetail/index')
const Tests = () => import('@/views/tests/index')
const TestsDetail = () => import('@/views/testsdetail/index')
/* const Ksbao = () => import('@/views/tests/compontents/ksbao.vue')
const Ahu = () => import('@/views/tests/compontents/ahu.vue')
const Zhukao = () => import('@/views/tests/compontents/zhukao.vue') */
const Read = () => import('@/views/read/index')
const About = () => import('@/views/about/index')

const Login = () => import('@/views/login/index')

const routes = [
  {
    path: '/',
    component: Layout,
    children: [
      { path: '/home', component: Home, meta: { scrollToTop: true } },
      { path: '/', component: Home, meta: { scrollToTop: true } },
      { path: '/user/pay', component: Pay, meta: { scrollToTop: true } },
      { path: '/user/payment', component: PayMent },
      { path: '/user/checkout', component: CheckOut },
      { path: '/user/mine', component: Mine },

      { path: '/news', component: News },
      /* { path: '/news/newslist', component: NewsList, meta: { scrollToTop: true } }, */
      { path: '/news/newsdetail', component: NewsDetail, meta: { scrollToTop: true } },

      { path: '/news/policy', component: NewsPolicy },
      /*  { path: '/news/detail', component: NewsDesc, meta: { scrollToTop: true } }, */

      { path: '/news/notice', component: NewsNotice },
      { path: '/news/newslist', component: NewsList },

      { path: '/examline/linelist', component: LineList },
      /* { path: '/news/newslist', component: NewsList, meta: { scrollToTop: true } }, */
      { path: '/examline/linedetail', component: LineDetail, meta: { scrollToTop: true } },

      { path: '/examline/lineitem', component: LineItem },

      { path: '/guide/guidelist', component: GuideList },
      { path: '/guide/guideitem', component: GuideItem },
      { path: '/guide/detail', component: GuideDetail },

      { path: '/advice/advicelist', component: AdviceList },

      { path: '/advice/adviceitem', component: AdviceItem },
      { path: '/advice/advicedetail', component: AdviceDetail },

      {
        path: '/video', component: Video, meta: { scrollToTop: true }
      },
      {
        path: '/video/videodetail', component: VideoDetail, meta: { scrollToTop: true }
      },
      //{ path: '/video/vid/:id/major/:id', component: Video, props: true },
      //{ path: '/videodetail', component: VideoDetail },
      { path: '/video/videoplay', component: VideoPlay },
      { path: '/books', component: Books },
      { path: '/books/booksdetail', component: BooksDetail, meta: { scrollToTop: true } },
      {
        path: '/tests', component: Tests,
        /*  children: [
           { path: '', component: Ksbao },
           //{ path: 'ksbao', component: Ksbao },
           { path: 'zhukao', component: Zhukao },
           { path: 'ahu', component: Ahu }
         ] */
      },
      {
        path: '/tests/testsdetail', component: TestsDetail, meta: { scrollToTop: true }
      },
      { path: '/login', component: Login },
      { path: '/read', component: Read },
      { path: '/about', component: About }
    ]
  }
]

// 创建路由实例
const router = createRouter({
  // 使用hash方式实现路由
  base: '/',
  history: createWebHistory(),//createWebHashHistory(),

  //mode: 'history',
  // 配置路由规则，写法和之前一样
  routes,
  //路由滚动行为，点击事件切换路由之后返回到顶部
  scrollBehavior(to, from, savedPosition) {
    if (to.matched.some(record => record.meta.scrollToTop)) {
      return {
        left: 0, top: 0
      }
    }
    if (savedPosition) {
      //console.log(savedPosition, 'savedPosition');
      return savedPosition
    }

  },


})

//前置路由导航守卫，以/** 开头的全部需要拦截并登录
router.beforeEach((to, from, next) => {
  const { profile } = store.state.user
  if (!profile.token && to.path.startsWith('/user')) {
    return next('/login?redirectUrl=' + encodeURIComponent(to.fullPath))
  }
  next()
})

export default router